var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'selected': _vm.isSelected },on:{"click":function($event){return _vm.$emit('update:selected', _vm.annotation)}}},[_c('annotation-preview',{staticClass:"annotation-data",attrs:{"annot":_vm.annotation,"images":_vm.images,"showDetails":false,"size":85,"users":_vm.users}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }